import Icon from '../components/Icon.vue'

Icon.register({
  crop: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 352c13.3 0 24 10.7 24 24v48c0 13.3-10.8 24-24 24h-40v40c0 13.3-10.8 24-24 24h-48c-13.3 0-24-10.8-24-24v-282.8l-146.8 146.8h114.8v96h-232c-13.3 0-24-10.8-24-24v-264h-40c-13.3 0-24-10.8-24-24v-48c0-13.3 10.8-24 24-24h40v-40c0-13.3 10.8-24 24-24h48c13.3 0 24 10.7 24 24v282.8l146.8-146.8h-114.8v-96h210.8l59.3-59.3c6.3-6.3 16.4-6.3 22.6 0l22.6 22.6c6.3 6.3 6.3 16.4 0 22.6l-59.3 59.3v242.8h40z'
      }
    ]
  }
})
